/**
 * pixelArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const pixelArtPack: ToilePack = {
    slug: 'pixel-art',
    category: 'pixel',
    name: 'Pixel art',
    tagline: tagline('sprites', 'characters', 'formats'),
    chips: chips('characters', 'formats'),
    ratio: SQUARE,
    readings: [
        {key: 'knight', label: 'Knight', subject: 'a small armored knight with a red plume and shield'},
        {key: 'slime', label: 'Slime', subject: 'a bouncy blue slime monster with big eyes'},
        {key: 'tavern', label: 'Tavern', subject: 'a cozy medieval tavern with a hanging sign'},
    ],
    styles: [
        {key: 'sprite', label: 'Sprite', style: 'single character sprite, magnified', palette: 'limited 16-bit palette', framing: 'flat solid background'},
        {key: 'sheet', label: 'Sprite sheet', style: 'sprite sheet, four-frame walk cycle', palette: 'limited 16-bit palette', framing: 'flat solid background'},
        {key: 'scene', label: 'Game tile', style: 'isometric game tile scene', palette: 'limited 16-bit palette', framing: 'ground tiles and props'},
    ],
    directions: ['a wizard instead', 'in a four-color palette', 'a night-time version'],
}
